import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CollectionpointMonthlyDetailReport } from './Pages/listing';

export const CollectionpointMonthlyDetailReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CollectionpointMonthlyDetailReport} />
    </Fragment>
)